module.exports = __webpack_public_path__ + "static/media/flixbusNew-mobile.ce932044.svg";